import React from 'react'
import { Icon } from '~common/components/icon'
import { useAppContext } from '~/app-context'

import styled from 'styled-components'
import { useTheme } from '~common/theme/theme-provider'

export interface ThemeToggleProps {
    showLabel?: boolean
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ showLabel }) => {
    const { isDark, toggleTheme } = useTheme()

    const label = showLabel ? 'Toggle Theme' : undefined

    return (
        <SettingsButtonContainer>
            <SettingsButtonButton onClick={toggleTheme}>
                <Icon name={isDark ? 'sun' : 'moon'} height={28} width={28} />
                <span>{label}</span>
            </SettingsButtonButton>
        </SettingsButtonContainer>
    )
}

const SettingsButtonButton = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing[2]};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 50px;
    width: 100%;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing[2]};
    border-radius: ${({ theme }) => theme.borderRadius.full};
    color: ${({ theme }) => theme.colors.greyScale[50]};
    gap: ${({ theme }) => theme.spacing[3]};
    cursor: pointer;
    &:hover {
        background-color: ${({ theme }) => theme.colors.greyScale[400]};
    }
`

const SettingsButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: calc(100% + ${({ theme }) => theme.spacing[4]});
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing[2]};
    margin-left: -${({ theme }) => theme.spacing[2]};
`
